import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  HomeOutlined,
  IdcardOutlined,
  NodeIndexOutlined,
  PullRequestOutlined,
  ScheduleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { dateWithName } from "../../../utils/dateWithName";
import { getMinutesFromNow } from "../../../utils/getMinutesFromNow";
import Counter from "../../../components/tagSelector/countDown/Counter";
import { getColor } from "./getColor";

export const RenglonSemaforo = ({
  asistencia: {
    estatusID,
    campania,
    ubicacion,
    servicio,
    asistenciaID,
    proveedor,
    localCarretero,
    esCita,
    esConexion,
    esGnpApi,
    fechaCita,
    fechaSugiereProveedor,
    fechaProveedorValidado,
    fechaTiempoLlegada,
    fechaIniciaAsignacion,
    usuarioInicioAsignacionAsistencia,
    countPropuestas,
    tienePlaca,
    urlPlaca,
    quienAsignaProveedor,
    enEsperaUsuario,
    fechaInicioEnEsperaDeUsuario,
    usuarioIniciaSeguimiento,
    hasIncidenciaArribo,
    hasIncidenciaAsignacion,
  },
  fecha,
}) => {
  const history = useHistory();
  const { minutos, lapso } = getMinutesFromNow(fecha);
  const [hover, setHover] = useState(false);
  const color = getColor(minutos, estatusID, localCarretero, esCita, fechaTiempoLlegada);
  const handleClick = () => history.push(`/detalleAsistencia/${asistenciaID}`);

  return (
    <div
      className={`semaforo__renglon semaforo-card ${color}`}
      onClick={handleClick}
      onKeyDown={(event) => event.key === "Enter" && handleClick()}
      role="link"
      tabIndex={0}
      aria-label={`Abrir asistencia ${asistenciaID}`}
    >
      <div className="semaforo-card__distintivos">
        <span className="semaforo-card__indicador" aria-label={`Semáforo ${color.replace("semaforo__", "")}`} />
        {esGnpApi && <span className="semaforo-card__distintivo semaforo-card__distintivo--api">API GNP</span>}
        {localCarretero && <span className="semaforo-card__distintivo">{localCarretero === "carretero" ? <NodeIndexOutlined /> : <HomeOutlined />}{localCarretero}</span>}
        {esCita && <span className="semaforo-card__distintivo semaforo-card__distintivo--api"><ScheduleOutlined className="semaforo-card__icono-pulso" /> Cita</span>}
        {esConexion && <span className="semaforo-card__distintivo"><PullRequestOutlined /> Conexión</span>}
        {enEsperaUsuario && <span className="semaforo-card__distintivo semaforo-card__distintivo--espera"><UserOutlined className="semaforo-card__icono-espera" /> Espera de usuario</span>}
        {hasIncidenciaArribo && <span className="semaforo-card__distintivo semaforo-card__distintivo--alerta">Incidencia de arribo</span>}
        {hasIncidenciaAsignacion && <span className="semaforo-card__distintivo semaforo-card__distintivo--alerta">Incidencia de asignación</span>}
        {usuarioIniciaSeguimiento && <span className="semaforo-card__distintivo">{usuarioIniciaSeguimiento}</span>}
        {fechaProveedorValidado && <span className="semaforo-card__distintivo"><CheckCircleOutlined /> Proveedor validado</span>}
        {estatusID === 2 && fechaSugiereProveedor && <span className="semaforo-card__distintivo semaforo-card__distintivo--espera semaforo-card__esperando-proveedor"><ClockCircleOutlined /> Esperando proveedor</span>}
        {tienePlaca && (
          <span
            className="semaforo-card__distintivo"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onFocus={() => setHover(true)}
            onBlur={() => setHover(false)}
            tabIndex={0}
          >
            <IdcardOutlined /> Placa
          </span>
        )}
      </div>

      <dl className="semaforo-card__datos">
        <div className="semaforo-card__folio"><dd>#{asistenciaID}</dd></div>
        <div><dd>{servicio}</dd></div>
        <div className="semaforo-card__tiempo">
          <dd>{estatusID === 3 ? fechaTiempoLlegada && <Counter targetDate={fechaTiempoLlegada} showHours showMinutes /> : lapso}</dd>
        </div>
        {fechaCita && <div><dt>Fecha de Cita</dt><dd>{dayjs(fechaCita).format("YYYY-MM-DD HH:mm")}</dd></div>}
        <div><dt>Campaña</dt><dd>{campania}</dd></div>
        <div><dt>Ubicación</dt><dd>{ubicacion}</dd></div>
        {estatusID > 2 && (
          <div className="semaforo-card__ancho semaforo-card__resumen-proveedor">
            <div><dt>Proveedor</dt><dd>{proveedor}</dd></div>
            {enEsperaUsuario && fechaInicioEnEsperaDeUsuario && (
              <div><dt>En espera desde</dt><dd>{dayjs(fechaInicioEnEsperaDeUsuario).format("YYYY-MM-DD HH:mm")}</dd></div>
            )}
            <div><dt>Quién asigna</dt><dd>{quienAsignaProveedor}</dd></div>
          </div>
        )}
        {estatusID === 2 && fechaSugiereProveedor && localCarretero === "carretero" && <div><dt>Propuestas</dt><dd>{countPropuestas}</dd></div>}
        {estatusID <= 2 && enEsperaUsuario && fechaInicioEnEsperaDeUsuario && <div className="semaforo-card__ancho"><dt>En espera desde</dt><dd>{dayjs(fechaInicioEnEsperaDeUsuario).format("YYYY-MM-DD HH:mm")}</dd></div>}
        {estatusID > 1 && usuarioInicioAsignacionAsistencia && fechaIniciaAsignacion && <div className="semaforo-card__ancho"><dt>Asignado desde cabina</dt><dd>{dateWithName(fechaIniciaAsignacion, usuarioInicioAsignacionAsistencia)}</dd></div>}
        {estatusID <= 2 && quienAsignaProveedor && <div className="semaforo-card__ancho"><dt>Quién asigna</dt><dd>{quienAsignaProveedor}</dd></div>}
      </dl>
      {hover && <img className="semaforo-card__placa" src={urlPlaca} alt="Placa de la asistencia" />}
    </div>
  );
};
